import type {SVGProps} from 'react';

export function Fa7SolidClipboard(props: SVGProps<SVGSVGElement>) {
    return (<svg xmlns="http://www.w3.org/2000/svg" width={"1em"} height={"1em"} viewBox="0 0 640 640" {...props}>
        <path fill="currentColor"
              d="M448 96h-8.6c-11-19.1-31.7-32-55.4-32H256c-23.7 0-44.4 12.9-55.4 32H192c-35.3 0-64 28.7-64 64v352c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64m-184 80c-13.3 0-24-10.7-24-24s10.7-24 24-24h112c13.3 0 24 10.7 24 24s-10.7 24-24 24z"></path>
    </svg>);
}